const portraitMq = window.matchMedia('(orientation: portrait)');

function isWebkit() {
  return 'GestureEvent' in window;
}

function isMobileWebKit() {
  return 'ongesturechange' in window;
}

function isDesktopWebKit() {
  return (
    typeof window !== 'undefined'
    && 'safari' in window
    && 'pushNotification' in window.safari
  );
}

function isIOS26Minimum() {
  return CSS.supports('text-wrap-style', 'pretty');
}

function getBottomSafeArea() {
  const svhTest = document.createElement('div');
  svhTest.style.cssText = `
    visibility: hidden;
    height: 100svh;
    position: absolute;
  `;
  document.documentElement.appendChild(svhTest);

  const viewportHeightTest = document.createElement('div');
  viewportHeightTest.style.cssText = `
    visibility: hidden;
    height: var(--viewport-height, 100svh);
    position: absolute;
  `;
  document.documentElement.appendChild(viewportHeightTest);

  const smallHeight = svhTest.offsetHeight;
  const viewportHeight = viewportHeightTest.offsetHeight;

  svhTest.remove();
  viewportHeightTest.remove();

  return viewportHeight - smallHeight;
}

export function needsIOSFix() {
  return (
    isWebkit()
    && isMobileWebKit()
    && !isDesktopWebKit()
    && isIOS26Minimum()
  );
}

function setBrowserVariables() {
  if (needsIOSFix()) {
    document.documentElement.style.setProperty('--ios-vh-fix', 'calc(100lvh + 58px)');
  } else {
    document.documentElement.style.removeProperty('--ios-vh-fix');
  }

  if (portraitMq.matches) {
    document.documentElement.style.setProperty('--viewport-height', 'var(--ios-vh-fix, 100svh)');
  } else {
    document.documentElement.style.setProperty('--viewport-height', '100svh');
  }

  document.documentElement.style.setProperty('--bottom-ui-safe-area', `${getBottomSafeArea()}px`);
}

export default function fullheightFix() {
  portraitMq.addEventListener('change', setBrowserVariables);

  setBrowserVariables();
}
